import styled from 'styled-components';

export const CouponContainer = styled.div`
  margin: 16px 0;
`;

export const CouponToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f9fafb;
  border: 1px dashed #9ca3af;
  border-radius: 8px;
  color: #4b5563;
  font-size: 14px;
  cursor: pointer;
  padding: 12px 16px;
  transition: all 0.3s;
  width: 100%;

  &:hover {
    color: #16a34a;
    border-color: #16a34a;
    background: #f0fdf4;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(22, 163, 74, 0.1);
  }

  svg {
    flex-shrink: 0;
    color: #9ca3af;
  }

  span {
    font-weight: 500;
  }
`;

export const CouponInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CouponInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const ApplyCouponButton = styled.button<{
  background: string;
  color: string;
}>`
  padding: 8px 16px;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;

export const CouponMessage = styled.div<{ success: boolean }>`
  font-size: 12px;
  color: ${(props) => (props.success ? '#16a34a' : '#dc2626')};
  padding: 4px 0;
`;
